// extracted by mini-css-extract-plugin
export default {"container":"SettingsContainer_container__xVTx+"};